export const propFaqBooking = {
  faqEditor: {
    empty: "Nie ma jeszcze żadnych pytań. Dodaj pierwsze, aby agent wiedział, jak na nie odpowiadać.",
    learnedTooltip: "Odpowiedź dodana dzięki samouczeniu od gospodarza",
    learnedBadge: "Nauczone",
    removeAttachment: "Usuń załącznik",
    uploading: "Przesyłanie…",
    attach: "Załącz",
    deleteTooltip: "Usuń",
    addQuestion: "Dodaj pytanie",
    qPlaceholder: "Pytanie · np. Czy jest parking?",
    aPlaceholder: "Odpowiedź · np. Tak, bezpłatny tuż przed budynkiem.",
    errors: {
      fillBeforeAttach: "Wpisz pytanie i odpowiedź przed dołączeniem plików.",
      saveBeforeAttach: "Najpierw zapisz, aby dołączać pliki.",
      uploadFailed: "Nie udało się przesłać pliku.",
      deleteFailed: "Nie udało się usunąć pliku.",
    },
  },
  faqSuggestions: {
    title: "Sugestie do nauki",
    intro: "Agent nie potrafił odpowiedzieć na te pytania, więc odpowiedź gościowi wysłano ręcznie. Przejrzyj je, w razie potrzeby popraw i zapisz, aby od teraz agent odpowiadał na nie samodzielnie.",
    askedLabel: "Gość zapytał",
    questionLabel: "Pytanie",
    questionPlaceholder: "Jak sformułować to pytanie?",
    answerLabel: "Odpowiedź agenta",
    answerPlaceholder: "Odpowiedź, której udzieli agent",
    applyToOthers: "Zastosuj także do innych jednostek w ofercie:",
    dismiss: "Odrzuć",
    saveAsAnswer: "Zapisz jako odpowiedź",
    errors: {
      saveFailed: "Nie udało się zapisać.",
      dismissFailed: "Nie udało się odrzucić.",
    },
  },
  sourceNote: {
    title: "Kolejność priorytetów odpowiedzi agenta",
    infoAria: "Zobacz kolejność priorytetów źródeł agenta",
    lead: "Gdy dwa źródła podają co innego w tej samej sprawie, agent stosuje tę kolejność:",
    faqPre: "FAQ ",
    faqStrong: "dla pojedynczej jednostki",
    faqTag: "wygrywa",
    configMain: "Ustawienia obiektu",
    configMuted: "· godziny, pojemność, usługi",
    kb: "Baza wiedzy",
  },
  bookingLinks: {
    title: "Jak gość rezerwuje",
    subPre: "Agent wysyła link do ",
    subStrong: "Rezerwacji Bezpośrednich",
    subPost: ", a gość rezerwuje przez internet.",
    step1Pre: "Jeśli gość wskaże ",
    step1Strong: "konkretny obiekt",
    step1Post: ", agent wysyła bezpośredni link do niego.",
    step2Pre: "Jeśli w okolicy jest ",
    step2Strong1: "kilka obiektów",
    step2Mid: ", agent ",
    step2Strong2: "wymienia każdy z nich wraz z linkiem",
    step2Post: " i podaje link ogólny.",
    step3Pre: "Jeśli nie zna okolicy, ",
    step3Strong: "proponuje dostępne lokalizacje",
    step3Post: " i pyta, gdzie gość chciałby się zatrzymać.",
    globalLinkLabel: "Link ogólny (wszystkie lokalizacje)",
    copy: "Kopiuj",
    copied: "Skopiowano",
    noIdNote: "Link do rezerwacji zostanie wygenerowany, gdy konto będzie mieć skonfigurowany identyfikator.",
    toastCopied: "Link skopiowany",
    toastCopyFailed: "Nie udało się skopiować",
  },
  bookingConfirm: {
    title: "Powiadom o nowej rezerwacji",
    subPre: "Gdy rezerwacja zostanie potwierdzona, automatycznie powiadamiamy gościa ",
    subStrong: "na WhatsApp",
    subPost: " o szczegółach pobytu.",
    toggleLabel: "Wysyłaj potwierdzenie na WhatsApp",
    toggleHint: "Po wyłączeniu tej opcji gość nie otrzyma tego powiadomienia. Jeśli rezerwacja pochodzi z OTA, powiadomi go OTA.",
    stateOn: "Tak, wysyłaj",
    stateOff: "Nie wysyłaj",
    notEditablePre: "Na razie treści tej wiadomości ",
    notEditableStrong: "nie można edytować",
    notEditablePost: ". Poniżej pokazujemy podgląd tego, co otrzymuje gość.",
    previewTag: "Podgląd · co widzi gość",
    online: "online",
    today: "Dzisiaj",
    previewHint: "Aktualizuje się wraz z konfiguracją",
    defaultListingName: "Obiekt",
    toastEnabled: "Powiadomienie o rezerwacji włączone",
    toastDisabled: "Powiadomienie o rezerwacji wyłączone",
    toastSaveFailed: "Nie udało się zapisać zmiany",
    previewGuest: "Laura García",
    previewBody: "Dzień dobry, *{guest}* 👋\n\nRezerwacja w obiekcie *{name}* jest potwierdzona ✅\n\nKod rezerwacji: *6233Q1VC5*\nTerminy: *05/06/2026* – *07/06/2026* 📅\n\nPrzez ten WhatsApp można poprosić o link do check-in online, a także otrzymać instrukcje dotyczące przyjazdu.\nW razie potrzeby pomocy przed pobytem lub w jego trakcie prosimy o wiadomość tutaj 💬",
    previewCta: "🇪🇸 Aby przejść do check-in, naciśnij przycisk *Ok* lub napisz *Ok*.",
  },
};
